// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__4Mi45","modalmain":"Modal_modalmain__02Gl4","displayblock":"Modal_displayblock__q14Y4","displaynone":"Modal_displaynone__QJFJC"};